/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const Timer2Icon = ({ className, color}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.04102 14.1626V8.07943C12.4175 8.07943 15.1242 10.8141 15.1242 14.1626C15.1242 15.781 14.4824 17.3158 13.3383 18.4599L9.04102 14.1626ZM3.12529 5.59594L4.18566 4.98205L4.85536 6.15403C5.83202 5.62385 6.92029 5.28899 8.09227 5.14947V3.72635H7.6458C7.03191 3.72635 6.55753 3.22407 6.55753 2.61017V1.88466C6.55753 1.29867 7.03191 0.796387 7.6458 0.796387H10.4641C11.0501 0.796387 11.5524 1.29867 11.5524 1.88466V2.61017C11.5524 3.22407 11.0501 3.72635 10.4641 3.72635H10.0177V5.14947C11.1618 5.28899 12.25 5.62385 13.2546 6.15403L13.9243 4.98205L14.9568 5.59594L14.287 6.76793C16.5752 8.41429 18.11 11.121 18.11 14.1626C18.11 19.1575 14.0359 23.2036 9.04102 23.2036C4.04614 23.2036 0 19.1575 0 14.1626C0 11.121 1.50684 8.41429 3.8229 6.76793L3.12529 5.59594ZM9.04102 21.8642C13.3104 21.8642 16.7426 18.4041 16.7426 14.1626C16.7426 9.89322 13.3104 6.46098 9.04102 6.46098C4.79956 6.46098 1.33941 9.89322 1.33941 14.1626C1.33941 18.4041 4.79956 21.8642 9.04102 21.8642ZM7.6458 1.494H10.4641C10.6595 1.494 10.8548 1.68933 10.8548 1.88466V2.61017C10.8548 2.83341 10.6595 3.00083 10.4641 3.00083H7.6458C7.42257 3.00083 7.25514 2.83341 7.25514 2.61017V1.88466C7.25514 1.68933 7.42257 1.494 7.6458 1.494Z"
        fill={color ? color : "#7E92A2"}
      />
    </svg>
  )
}
